"use client";

import { Suspense } from "react";

import { UserButton } from "@/components/auth/user-button";
import { MainNav } from "@/components/nav/main-nav";
import { MobileNav } from "@/components/nav/mobile-nav";
import { Skeleton } from "@/components/ui/skeleton";
import { Stack } from "@/components/ui/stack";

import { type NavigationConfig, navConfig } from "@/config/nav";
import { useAuth } from "@/lib/auth/client";

import { ConstrainedContent } from "../constrained-content";

type SiteHeaderVariant = "sticky" | "static";

export function SiteHeader({
  title,
  variant = "sticky",
  config,
}: {
  title?: string;
  variant?: SiteHeaderVariant;
  config?: NavigationConfig;
}) {
  const { user } = useAuth();

  const configuration = config ?? navConfig(user?.accessLevel);
  const className =
    variant === "sticky"
      ? "sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur-sm supports-backdrop-filter:bg-background/60"
      : "border-b bg-white shrink-0";

  const headerHeight = "h-14"; // fix header height to 14 rem

  return (
    <header className={className}>
      <ConstrainedContent>
        <Stack
          direction="row"
          align="center"
          justify="between"
          className={headerHeight}
        >
          <div>
            <MainNav title={title} config={configuration} />
            <MobileNav config={configuration} />
          </div>
          <Suspense fallback={<Skeleton loading className="size-8" />}>
            <UserButton user={user} />
          </Suspense>
        </Stack>
      </ConstrainedContent>
    </header>
  );
}
